import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { ResponseUSer } from 'src/app/_models';

import { Router } from '@angular/router';
import { EncrDecrService } from './encr-decr-service.service';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<ResponseUSer>;
  public currentUser: Observable<ResponseUSer>;

  constructor(
    private http: HttpClient,
    private router: Router,
    private EncrDecr: EncrDecrService
  ) {
    this.currentUserSubject = new BehaviorSubject<ResponseUSer>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): ResponseUSer {
    return this.currentUserSubject.value;
  }

  login(
    useremail: string,
    keyAccess: string,
    plataforma: string = 'WAREHOUSE'
  ) {
    return this.http
      .post<any>(
        `${environment.apiUrl}/Login/LoginUsers`,
        { useremail, keyAccess, plataforma },
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Access-Control-Allow-Origin',
            'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
            withCredentials: 'true',
          }),
        }
      )
      .pipe(
        map((ResponseUSer) => {
          
          if (ResponseUSer != null || ResponseUSer != 'indefine') {
            localStorage.setItem('LogAut', 'true');
            localStorage.setItem(
              'LogAutUs',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', useremail)
            );
            localStorage.setItem(
              'LogAutPas',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', keyAccess)
            );

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(ResponseUSer));
            //localStorage.setItem('currentUserTokenApi', JSON.stringify(token));
            this.currentUserSubject.next(ResponseUSer);
          }

          return ResponseUSer;
        })
      );
  }
  loginapp(
    useremail: string,
    keyAccess: string,
    plataforma: string
  ) {
    return this.http
      .post<any>(
        `${environment.apiUrl}/Login/LoginUsers3pl`,
        { useremail, keyAccess, plataforma },
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Access-Control-Allow-Origin',
            'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
            withCredentials: 'true',
          }),
        }
      )
      .pipe(
        map((ResponseUSer) => {
          
          if (ResponseUSer != null || ResponseUSer != 'indefine') {
            localStorage.setItem('LogAut', 'true');
            localStorage.setItem(
              'LogAutUs',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', useremail)
            );
            localStorage.setItem(
              'LogAutPas',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', ResponseUSer.pass)
            );

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(ResponseUSer.LoginResponse));
            //localStorage.setItem('currentUserTokenApi', JSON.stringify(token));
            this.currentUserSubject.next(ResponseUSer.LoginResponse);
          }

          return ResponseUSer;
        })
      );
  }

  login3plapp(
    id: number,
    whId: number,
    useremail: string,
    token: string
  ) {
    return this.http
      .post<any>(
        `${environment.apiUrl}/Login/LoginUsers3plapp`,
        { id, whId, useremail },
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Access-Control-Allow-Origin',
            'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
            withCredentials: 'true',
            Authorization: 'Bearer ' + token
          }),
        }
      )
      .pipe(
        map((ResponseUSer) => {
          
          if (ResponseUSer != null || ResponseUSer != 'indefine') {
            localStorage.setItem('LogAut', 'true');
            localStorage.setItem(
              'LogAutUs',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', useremail)
            );
            localStorage.setItem(
              'LogAutPas',
              this.EncrDecr.set('3PLsofwareTeam$#@$^@1ERF', ResponseUSer.pass)
            );

            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(ResponseUSer.LoginResponse));
            //localStorage.setItem('currentUserTokenApi', JSON.stringify(token));
            this.currentUserSubject.next(ResponseUSer.LoginResponse);
          }

          return ResponseUSer;
        })
      );
  }
  Signallogin(
    useremail: string,
    keyAccess: string,
    plataforma: string = 'WAREHOUSE'
  ) {
    return this.http
      .post<any>(
        `${environment.apiSignalR}/api/LoginUsers`,
        { useremail, keyAccess, plataforma },
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Access-Control-Allow-Origin',
            'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS',
            withCredentials: 'true',
          }),
        }
      )
      .pipe(
        map((ResponseUSer) => {
          console.log(ResponseUSer);
          if (ResponseUSer != null || ResponseUSer != 'indefine') {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('SignalR', JSON.stringify(ResponseUSer));
            //localStorage.setItem('currentUserTokenApi', JSON.stringify(token));
          }

          return ResponseUSer;
        })
      );
  }
  currentEuroRates: string;

  logout() {
    localStorage.clear();
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('SignalR');
    localStorage.removeItem('LogAut');
    localStorage.removeItem('LogAutUs');
    localStorage.removeItem('LogAutPas');
   
    this.currentUserSubject.next(null);
try {
  var element = document.getElementById('fondo');
  element.classList.add('fondo');
} catch (error) {
  
}
    this.router.navigate(['/login']);
  }
}
